// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@components";

import actionCreator from "@modules/shared/actionCreator";
import { AbsenceRTWInterviewView } from "./absence-rtw-interview-view";
import { RTWTaskDetailsSection } from "@modules/reporting/components";
import type { SelectedTask } from "@modules/reporting/reducer/tasks/types";

type OwnProps = $Exact<{
  task: SelectedTask,
  onCancel: Function,
  clientId?: number,
  isReports?: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const AbsenceRTWInterviewModal = (props: Props) => (
  <Modal className="modal-normal">
    <ModalHeader toggle={props.onCancel} className="d-flex justify-content-between">
      {props.t("INTERVIEW_ABSENCE_ITEM_TITLE", {
        id: (props.task || {}).id,
      })}
    </ModalHeader>
    <ModalBody>
      {(props.task.status === "OPEN" || props.task.status === "DRAFT") && props.isReports ? (
        <RTWTaskDetailsSection
          toggleTasksSection={() => null}
          isTasksHidden={false}
          selectedTask={props.task}
          clientId={props.clientId}
          employeeId={props.task.employee.id}
          isReports={props.isReports}
        />
      ) : (
        <AbsenceRTWInterviewView
          t={props.t}
          data={{
            completedBy: props.task.completedBy,
            completionDate: props.task.completionDate,
            questionAnswers: props.task.questionAnswers,
            rtwAt: props.task.rtwDate,
            dueDate: props.task.dueDate,
            hasExpired: false,
          }}
        />
      )}
    </ModalBody>
    <ModalFooter>
      <Button onClick={props.onCancel}>{props.t("CLOSE")}</Button>
    </ModalFooter>
  </Modal>
);

export default localize()(AbsenceRTWInterviewModal);
